import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import './legend-style.css'
import './leaflet-measure.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { ReactQueryDevtools } from 'react-query/devtools'

import i18n from './i18n' // do not remove

ReactDOM.render(
    <React.StrictMode>
        {/* No authentication needed for public access */}
        <App />
        {!process.env.REACT_APP_DEBUG && <ReactQueryDevtools initialIsOpen />}
    </React.StrictMode>,
    document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
